/**
 * CLDR JavaScript Library v0.5.4
 * http://jquery.com/
 *
 * Copyright 2013 Rafael Xavier de Souza
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2020-10-22T15:56Z
 */
/*!
 * CLDR JavaScript Library v0.5.4 2020-10-22T15:56Z MIT license © Rafael Xavier
 * http://git.io/h4lmVg
 */

// Cldr
module.exports = require( "./cldr" );

// Extent Cldr with the following modules
require( "./cldr/event" );
require( "./cldr/supplemental" );
require( "./cldr/unresolved" );



/*****************
 ** WEBPACK FOOTER
 ** ./~/cldrjs/dist/node_main.js
 ** module id = 56
 ** module chunks = 1 2 6 9 10 11 12
 **/